import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, light = true, center = false }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-14`}>
    <Reveal>
      <span className={`eyebrow mb-5 ${center ? "justify-center" : ""}`}>{eyebrow}</span>
    </Reveal>
    <Reveal delay={0.05}>
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mt-4 mb-4">
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.1}>
        <p className="text-base md:text-lg text-slate-400 leading-relaxed">{subtitle}</p>
      </Reveal>
    )}
  </div>
);
